(() => {
 const init=()=>document.querySelectorAll('.wb-header').forEach(header=>{
  if(header.dataset.megaReady)return;header.dataset.megaReady='true';
  const menus=[...header.querySelectorAll('.wb-nav-desktop .wb-department')];
  const desktop=matchMedia('(min-width:750px) and (hover:hover)');let timer;
  const close=()=>menus.forEach(menu=>menu.open=false);
  menus.forEach(menu=>{
   const enter=()=>{if(!desktop.matches)return;clearTimeout(timer);menus.forEach(other=>{if(other!==menu)other.open=false});menu.open=true;};
   menu.addEventListener('pointerenter',enter);menu.querySelector('.wb-submenu').addEventListener('pointerenter',enter);
   menu.querySelector('summary').addEventListener('click',event=>{if(desktop.matches&&event.detail>0){event.preventDefault();enter();}});
   menu.addEventListener('pointerleave',()=>{if(desktop.matches)timer=setTimeout(()=>{if(!menu.matches(':hover'))menu.open=false;},300);});
   menu.addEventListener('toggle',()=>{if(menu.open)menus.forEach(other=>{if(other!==menu)other.open=false});});
   menu.addEventListener('focusout',event=>{if(!menu.contains(event.relatedTarget))menu.open=false;});
   menu.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();menu.open=false;menu.querySelector('summary').focus();}});
  });
  document.addEventListener('pointerdown',event=>{if(!header.contains(event.target))close();});
  desktop.addEventListener('change',close);
 });
 init();document.addEventListener('shopify:section:load',init);
})();